import React, { Component } from "react";
import { Link } from "react-router-dom";

class SubNavBranding extends Component {
  render() {
    return (
      <div className="subnav">
        <ul align="center">
          <li className="subnav-item">
            <Link to="/Branding/thai-chix">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1540403678/rtds_work/Logo/ThaiChixLogoMockup.jpg"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/Branding/eatsinthewest">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1542912509/rtds_work/Eats%20in%20the%20West/eatsinthemwest-logo-mock.jpg"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/Branding/omg">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1540401409/rtds_work/Logo/OMGLogoMockup.jpg"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/Branding/mashiso">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1540402218/rtds_work/Logo/MashisoLogoMockup.jpg"
                alt="client-app"
              />
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default SubNavBranding;



// WEBPACK FOOTER //
// ./src/components/pages/category/SubNavBranding.js